import dynamic from 'next/dynamic'
import { Spacer } from '@smuchile/pkg-unimarc-components'
import {
  addToHomeData,
  useAndesMLClickEvent,
  UseQueryResult,
  visiblePromosScroll
} from '@smuchile/pkg-unimarc-hooks'
import { ICategories } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/ICategories'
import { MonetiseBannerProps } from '../../MonetiseBanner'
import { bannerData } from 'shared/helpers/bannerData'

export const MonetiseBanner = dynamic<MonetiseBannerProps>(
  import('../../').then((mod) => {
    return mod.MonetiseBanner
  })
)

interface IMoneticeBanner extends MonetiseBannerProps {
  isLoadingPage: boolean
  resultAisles: UseQueryResult<ICategories, unknown>
}

export const MonetiseBannerPLP = ({
  data,
  images,
  imageAndes,
  isLoadingPage,
  padding,
  resultAisles,
  urlLink
}: IMoneticeBanner) => {
  const { handleClickOnAndesMLBanner } = useAndesMLClickEvent()
  const catchMoneticeRefBanner = (ref: HTMLElement) => {
    if (data) {
      const promoData = bannerData(data)
      addToHomeData({ ref, promoData })
      visiblePromosScroll({})
    }
  }

  return (
    <>
      {resultAisles?.data && !isLoadingPage && (
        <MonetiseBanner
          catchMoneticeRefBanner={catchMoneticeRefBanner}
          data={data}
          handleClickOnAndesMLBanner={handleClickOnAndesMLBanner}
          imageAndes={imageAndes}
          images={images}
          padding={padding}
          urlLink={urlLink}
        />
      )}
      {!images && <Spacer.Horizontal size={24} />}
    </>
  )
}
